export interface UltimateUpscalePayloadParams {
  width: number;
  height: number;
  imageUrl: string;
  inputs: any; // Raw meta.inputs.inputs object
  loraUrl: string;
}

/**
 * Build the payload expected by the `comfy/Prompt-Hunt/upscale-w-ultimate-sd-upscale-w-moondream-production` service.
 * This consolidates logic previously duplicated in multiple API routes.
 */
export function buildUltimateUpscalePayload({
  width,
  height,
  imageUrl,
  inputs,
  loraUrl,
}: UltimateUpscalePayloadParams) {
  return {
    negative_prompt: inputs?.negative_prompt || "",
    prompt_positive: inputs?.prompt || "",
    user_lora_strength: inputs?.user_lora_strength || 0,
    lora_strength: inputs?.lora_strength || 0,
    fluxguidance_guidance: inputs?.fluxguidance_guidance,
    ksampler_seed: inputs?.ksampler_seed,
    ksampler_cfg: inputs?.ksampler_cfg,
    ksampler_steps: inputs?.ksampler_steps,

    remoteloraloader_fal_lora_url: loraUrl,
    face_detailer_prompt: inputs?.face_detailer_prompt || "",

    modelsamplingflux_width: width || 1024,
    modelsamplingflux_height: height || 1024,
    // training_image_url: "",
    image_url: imageUrl,
  };
}
